/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FishbrainLoginRequest
 */
export interface FishbrainLoginRequest {
    /**
     * 
     */
    refreshToken: string;
}

/**
 * Check if a given object implements the FishbrainLoginRequest interface.
 */
export function instanceOfFishbrainLoginRequest(value: object): value is FishbrainLoginRequest {
    if ((!('refreshToken' in (value as Record<string, any>)) && !('refresh_token' in (value as Record<string, any>))) || ((value as Record<string, any>)['refreshToken'] === undefined && (value as Record<string, any>)['refresh_token'] === undefined)) return false;
    return true;
}

export function FishbrainLoginRequestFromJSON(json: any): FishbrainLoginRequest {
    return FishbrainLoginRequestFromJSONTyped(json, false);
}

export function FishbrainLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FishbrainLoginRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'refreshToken': json['refresh_token'],
    };
}

export function FishbrainLoginRequestToJSON(json: any): FishbrainLoginRequest {
    return FishbrainLoginRequestToJSONTyped(json, false);
}

export function FishbrainLoginRequestToJSONTyped(value?: FishbrainLoginRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'refresh_token': value['refreshToken'],
    };
}

